/**
 * Activate sticky header bar
 */
export const initVideoPopup = (md) => {
    $('.video-popup__action--close').click(function(e){
        e.preventDefault();
        $('.screen-mask').removeClass('screen-mask--active');
        $('.video-popup').removeClass('video-popup--active');
        $('.video-popup__iframe').attr('src','about:blank');
    });
    $('a.video-popup-link').click(function(e){
        e.preventDefault();
        $('.screen-mask').addClass('screen-mask--active');
        $('.video-popup').addClass('video-popup--active');
        $('.video-popup__iframe').attr('src',$(this).attr('href'));
    });
};
